import React from "react";
import {
  Table,
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";

const PaymentSummary: React.FC = () => {
  return (
    <div className="p-2">
      <PageHeader
        title="Payment Summary"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />
      <Card className="mt-3 shadow-sm">
        <CardBody>
          <Row className="align-items-center mb-3">
            <Col md="9">
              <h5 className="mb-0 fw-bold">Expense Monthly Summary Report</h5>
            </Col>
            <Col
              md="3"
              className="d-flex justify-content-end align-items-center gap-2"
            >
              <RoundedDropdown
                options={[]}
                onSelect={(e) => console.log("status", e)}
                defaultLabel="All"
                width="120px"
                isShowHeading
                DropdownHeading="Month"
                headingColor="#2e8dd3"
              />
            </Col>
          </Row>

          <Table bordered responsive>
            <thead className="text-center">
              <tr>
                <th colSpan={6} className="text-center fw-bold">
                  Expense Monthly Summary Report | February 2025
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="fw-medium">Employee Name</td>
                <td colSpan={5}>sachin kadam [001]</td>
              </tr>
              <tr>
                <td className="fw-medium">Designation</td>
                <td colSpan={5}>CMD @ Head Office</td>
              </tr>
              <tr>
                <td className="fw-medium">Working Status</td>
                <td colSpan={5}>
                  <Badge color="success">Yes</Badge>
                </td>
              </tr>
              <tr className="text-center fw-bold">
                <td>Particulars</td>
                <td>Requests</td>
                <td>Deduction by Approver</td>
                <td>Net Payable Amount</td>
                <td>Audit Changes</td>
                <td>Final Payable Amount</td>
              </tr>
              <tr className="text-center">
                <td className="fw-bold">Total</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td colSpan={5} className="fw-bold text-end">
                  Final Payable Amount{" "}
                  <span className="text-muted">(Indian Rupee)</span>
                </td>
                <td className="fw-bold text-center">0</td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
};

export default PaymentSummary;
